module.exports = __webpack_public_path__ + "FixelDisplay-LightItalic-06b10e221b940668375f00a6c156523c.woff2";